import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitByCurrentPersonData from './GetOrgUnitByCurrentPersonData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: []
};

const OrgUnitData = {
  INITIAL_STATE, getOrgUnitByCurrentPersonData
}

export default OrgUnitData;